import { Layout } from 'components/common/layout/Layout';
import { gql, useQuery } from 'urql';
import { CustomSEO } from '../../../components/common/layout/HeadMeta';
import { CalendarSection } from '../../../components/partners-new/ind-partners/CalendarSection';
import { PartDescr } from '../../../components/partners-new/ind-partners/PartDescr';
import { PartnersHeaderTabs } from '../../../components/partners-new/ind-partners/PartnersHeaderTabs';
import { QuoteSection } from '../../../components/partners-new/ind-partners/QuoteSection';
import { PlayVsLogo } from '../../../components/svg/partners/PlayVsLogo';
import { OrgPlayvsIndexDocument, OrgPlayvsIndexQuery } from '../../../generated/spin-graphql';
import { UrqlSSGForPage } from '../../../server/utils/serverUtils/ssg.utils';

gql`
    query OrgPlayvsIndex {
        espin_org_month(where: { org: { definition: { _eq: "playvs" } } }) {
            month
            total_days
            start_day
            month_of_year
            days {
                date
                title
                time
                game_def
                game {
                    game_definition
                }
            }
        }
    }
`;

export default function IhseaHome() {
    const title = 'PlayVS Partner';
    const description = 'Your home for Stay Plugged In & PlayVS content & scholarships.';
    const seoOverride: CustomSEO = {
        title: title,
        description: description,
    };

    const [result] = useQuery<OrgPlayvsIndexQuery>({ query: OrgPlayvsIndexDocument });
    const months = result?.data?.espin_org_month ?? [];

    const descrOne = `The services, events, resources and content that Stay Plugged In will provide in collaboration with PlayVS will allow coaches, student-athletes and parents to use them for collegiate recruiting opportunities. With over $20 million available for college esports scholarships yearly, this partnership will bridge the gap between the fastest-growing high school sport and opportunities becoming increasingly available at the collegiate level.`;

    // const descrAct1 =
    //     'Stay Plugged In & IEN will host a virtual recruiting showcase per semester, starting in the Spring of 2023. These virtual showcases are designed to highlight competitive matches between players who participate in IEN. With hundreds of colleges on the platform, there are an abundance of opportunities for students looking to gain collegiate scholarships.';

    // const items = [
    //     'Spring Showcase 2023: Feb 25th',
    //     'Game Titles - Rocket League, Valorant & League of Legends',
    //     'Swiss format with guaranteed three matches',
    //     'Competition begins at 2 PM ET',
    //     'Hosted online, registration coming soon',
    // ];

    // const descrPanel = `Over the course of the academic year, IHSEA & SPIN will be hosting educational panels to discuss esports recruiting opportunities and how to best purse them. Topics will range from how to best use the Stay Plugged In platform to tips & tricks for recruiting. The number of esports scholarship opportunities is incredible, where just for the Class of 2022, SPIN faciliated over $15 million in scholarships through our platform. See below for when we will be hosting a panel or town hall for your game.`;

    // const itemsPanel2 = [
    //     'August 31 | IEN Coaches Kick-Off',
    //     'September 14 | IEN Players & Parents',
    //     'November 30 | IEN Coaches Semester End Town Hall',
    //     'December 7 | IEN Players End of Semester Town Hall',
    // ];

    // const itemsPanel = [
    //     'February 1 | IEN Coaches Kick-Off',
    //     'February 8 |  IEN Players & Parents',
    //     'April 8 |  IEN Coaches Semester End Town Hall',
    //     'April 15 | IEN Players End of Semester Town Hall',
    // ];

    const btnText = `PLAYVS`;
    const btnLink = `https://www.playvs.com/`;

    return (
        <Layout seoOverride={seoOverride}>
            <PartnersHeaderTabs
                tabOneTitle={'General'}
                tabOneRoute={'/partners/playvs'}
                tabTwoTitle={'Recruiting'}
                tabTwoRoute={'/partners/playvs/recruiting'}
                tabThreeTitle={'Rankings'}
                tabThreeRoute={'/partners/playvs/rankings'}
                icon={<PlayVsLogo className="playvs" />}
            />
            <PartDescr label={'Our Partnership'} description={descrOne} btnText={btnText} btnLink={btnLink} />
            <QuoteSection
                className="ihsea-quote"
                quoteTwo={`At Stay Plugged In, we have always been committed to helping students find opportunities through esports," said Rick Suarez, Managing Director, Stay Plugged In. "This partnership with PlayVS will enable us to have an even larger reach to help continue to provide a clear pathway of opportunity for students who are passionate about esports, whether that pathway is to college, to the workforce, or both. We are excited to get started with the team at PlayVS as they continue to pioneer solutions that support amateur esports.`}
                personTwo={'Rick Suarez, Managing Director of Stay Plugged In'}
                quote={`PlayVS and Stay Plugged In share a similar vision for the high school esports space; to help evolve the industry and deliver pathways to college and beyond," said Aakash Ranavat, Chief Business Officer, PlayVS. "This partnership with Stay Plugged In delivers both premier events and the resources needed to unlock the potential to earn scholarships for students across the country.`}
                person={'Aakash Ranavat, Chief Business Officer, PlayVS'}
            />
            <div className="container">
                {months?.length > 0 && <CalendarSection months={months} twitchSlug={`ihsen`} />}
                {months?.length === 0 && (
                    <div className="no-cal-card">
                        <p>{`Calendar Coming Soon!`}</p>
                    </div>
                )}
            </div>
        </Layout>
    );
}

export async function getStaticProps(ctx) {
    return UrqlSSGForPage(OrgPlayvsIndexDocument);
}
